export default __webpack_public_path__ + "static/media/MachineryExpensTemplate.540896b0.xlsx";